let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9HbdP")).then(() => parcelRequire('9CRO6'));